export const getFullName = (colaborator) => {
  const name = colaborator.sNombre || ''
  const lastName = colaborator.sApellidoPaterno || ''
  const surName = colaborator.sApellidoMaterno || ''
  return `${name} ${lastName} ${surName}`.toUpperCase()
}
export const getOnlyName = (colaborator) => {
  const name = colaborator.sNombre || ''
  return `${name}`.toUpperCase()
}
export const getLastname = (colaborator) => {
  const lastName = colaborator.sApellidoPaterno || ''
  const surName = colaborator.sApellidoMaterno || ''
  return `${lastName} ${surName}`.toUpperCase()
}
export const sortNameASC = (a, b) => {
  const fullNameA = getFullName(a)
  const fullNameB = getFullName(b)
  if (fullNameA < fullNameB) {
    return -1
  }

  if (fullNameA > fullNameB) {
    return 1
  }

  return 0
}
export const sortNameDSC = (a, b) => {
  const fullNameA = getFullName(a)
  const fullNameB = getFullName(b)
  if (fullNameB < fullNameA) {
    return -1
  }

  if (fullNameB > fullNameA) {
    return 1
  }

  return 0
}
export const sortOnlyNameASC = (a, b) => {
  const fullNameA = getOnlyName(a)
  const fullNameB = getOnlyName(b)
  if (fullNameA < fullNameB) {
    return -1
  }

  if (fullNameA > fullNameB) {
    return 1
  }

  return 0
}
export const sortOnlyNameDSC = (a, b) => {
  const fullNameA = getOnlyName(a)
  const fullNameB = getOnlyName(b)
  if (fullNameB < fullNameA) {
    return -1
  }

  if (fullNameB > fullNameA) {
    return 1
  }

  return 0
}
export const sortLastnameASC = (a, b) => {
  const fullNameA = getLastname(a)
  const fullNameB = getLastname(b)
  if (fullNameA < fullNameB) {
    return -1
  }

  if (fullNameA > fullNameB) {
    return 1
  }

  return 0
}
export const sortLastnameDSC = (a, b) => {
  const fullNameA = getLastname(a)
  const fullNameB = getLastname(b)
  if (fullNameB < fullNameA) {
    return -1
  }

  if (fullNameB > fullNameA) {
    return 1
  }

  return 0
}
export const dniCharacters = (dni) => {
  const formatDNI = dni.replace('.', '').replace('.', '').replace('-', '')

  return formatDNI.slice(0, formatDNI.length - 1)
}
export const sortDniASC = (a, b) => {
  const newA = Number(dniCharacters(a.sRut || a.sRUT))
  const newB = Number(dniCharacters(b.sRut || b.sRUT))
  if (newA < newB) {
    return -1
  }

  if (newA > newB) {
    return 1
  }

  return 0
}
export const sortDniDSC = (a, b) => {
  const newA = Number(dniCharacters(a.sRut || a.sRUT))
  const newB = Number(dniCharacters(b.sRut || b.sRUT))
  if (newB < newA) {
    return -1
  }

  if (newB > newA) {
    return 1
  }

  return 0
}
export const sorting = (array, callback) => {
  return array.sort(callback)
}
